module.exports = __webpack_public_path__ + "img/hr2.5778541.png";